module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\"><g id=\"Page-1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"ic_cast2_black_24dp\"><g id=\"ic_remove_circle_white_24dp\"><path d=\"M1 18v3h3c0-1.66-1.34-3-3-3zM1 14v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7z\" id=\"Path\" opacity=\".3\" fill=\"#000\"></path><path d=\"M1 10v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11z\" id=\"Path\" fill=\"#000\"></path><path d=\"M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z\" id=\"cast\" fill=\"#000\"></path><path id=\"bounds\" d=\"M0 0h24v24H0z\"></path></g></g></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/public/ic_cast2_24dp.svg
// module id = 20
// module chunks = 0